import React, { useEffect, useState } from "react";
import { Card, Button, TextField, Box, palette } from "@material-ui/core";
import { useStyles } from "../../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
    companyListAction, updateCompanyAction
} from "../../../redux/actions/CompanyActions";
import SimpleMenu from "../../../components/layouts/Navigation";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchBar from "material-ui-search-bar";
import { useHistory, Link } from "react-router-dom";
import {
    createStyles,
    Theme,
    withStyles,
    WithStyles,
} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import logo from "../../../logo.png";
import { RegisterAction } from "../../../redux/actions/AuthActions";
import * as ActionTypes from "../../../redux/ActionTypes";
import PhoneInput from 'react-phone-input-2';
import Geographical from "../../../constants/Geographical.json";
import 'react-phone-input-2/lib/material.css';
import parse from 'html-react-parser';
import AuthorizationErrorComponent from '../../AuthorizationErrorComponent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    searchBox: {
        '@media (max-width: 768px)': {
            marginBottom: "15px"
        }
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
export default function CompanyListing(props) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    const companiesListResponse = useSelector((state) => state.companiesInfo.companiesList);
    //const companies = useSelector((state) => state.companiesInfo.companies);
    const [searched, setSearched] = useState("");
    const [rows, setRows] = useState([]);
    const [searchKey,setSearchKey] = useState("all");
    const [searchKeyValue, setSearchKeyValue] = useState("");
    const [applicationTypeKey, setApplicationTypeKey] = React.useState("all");
    const [restrictedStatus, setRestrictedStatus] = useState(false);
    const [restrictedResponse, setRestrictedResponse] = useState("");
    const [bodyStatus, setBodyStatus] = useState(false);
    const [companies, setCompanies] = useState(false);
    const [companyEditFlag, setCompanyEditFlag] = useState(false);
    const [columns,setColumns] = useState([]);
    const [tableConfig, setTableConnfig] = useState({
        total: 0,
        per_page: 10,
    });
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    

    const [fields, setState] = useState({
        name_of_company: "",
        company_registration_date: "",
        company_registration_number: "",
        company_pan_number: "",
        company_contact_number: "",
        company_district: "",
        company_province: "",
        company_city: "",
        company_ward: "",
        company_place: "",
        company_email:"",
        id: null,
        is_active: false
    });
    const labelList = {
        all:"All",
        name_of_company: "Company",
        company_registration_date: "Registration Date",
        company_registration_number: "Registration Number",
        company_pan_number: "PAN Number",
        company_contact_number: "Contact Number",
        // company_district: "District",
        // company_province: "Province",
        // company_city: "City",
        // company_ward: "Ward",
        company_place: "Place",
        company_email: "Email",
        is_active: "Status"
    };
    const columnsA = [
        { field: "id", headerName: "ID", width: 100, cellClassName: "cell_class_name" },
        { field: "name_of_company", headerName: "Name of Company", width: 190, cellClassName: "cell_class_name" },
        { field: "company_registration_date", headerName: "More information", width: 230, cellClassName: "cell_class_name" },
         { field: "company_contact_number", headerName: "Contact", width: 130, cellClassName: "cell_class_name" },
        { field: "company_place", headerName: "Place", width: 130 },
        { field: "company_email", headerName: "Email", width: 130 },
        { field: "is_active", headerName: "Status", width: 130 },
        { field: "actions", headerName: "Actions", width: 130 }
    ];
    const columnsB= [
        { field: "id", headerName: "ID", width: 100, cellClassName: "cell_class_name" },
        { field: "name_of_company", headerName: "Name of Company", width: 190, cellClassName: "cell_class_name" },
        { field: "company_registration_date", headerName: "More information", width: 230, cellClassName: "cell_class_name" },
        { field: "company_contact_number", headerName: "Contact", width: 130, cellClassName: "cell_class_name" },
        { field: "company_place", headerName: "Place", width: 130 },
        { field: "company_email", headerName: "Email", width: 130 },
        { field: "is_active", headerName: "Status", width: 130 },
    ];
   
    const getDistrictName = (company) => {
        
        Geographical.map((option) => { 
            if (option.id == company.company_province){
                company.company_province = option.name;
                 option.districts.map((district,index)=>{
                        if(district.id==company.company_district){

                            company.company_district = district.name;
                            district.municipalities.map((city, key) => {
                                if (city.id == company.company_city){
                                    company.company_city = city.name
                                    city.wards.map((ward, key) => {
                                        if (ward == company.company_ward){
                                            company.company_ward = ward;
                                        }

                                    }) /*ward mapping not needed just done for fun */
                                }
                            })
                        }
                 })
            }
        })
       // company.company_province = company.company_province + '<br/>' + company.company_district + '<br/>' + company.company_city + '<br/>' + company.company_ward
        return company;
    }
    const editUser = (event, row) => {
        

        setState({
            ...fields,
            name_of_company: row.name_of_company,
            company_registration_date: row.company_registration_date,
            company_registration_number:row.company_registration_number,
            company_pan_number: row.company_pan_number,
            id: row.id,
            company_contact_number: row.company_contact_number,
            company_province: row.company_province,
            company_district: row.company_district,

            company_city:row.company_city,
            company_ward:row.company_ward,
            company_place: row.company_place,
            company_email: row.company_email,

            is_active: row.is_active
        });

       
        
        dispatch({ type: ActionTypes.FREE_USER_STATE, companiesListResponse });


        setOpen(true);
    };
    const deleteUser = (event, param) => {
        event.stopPropagation();
        //dispatch(CustomerDeleteAction(param.row, history));
    };
    const requestSearch = (searchedVal) => {
       
        companies.map((element) => (
            element.status = (element.status === null || element.status === 0) ? "Inactive" : "Active"

        ))
        companies.map((element) => (
            element = getDistrictName(element)
        ))
        setSearchKeyValue(searchedVal);
        setPage(0);

        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal; 

        dispatch(companyListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setCompanies, signal, setCompanyEditFlag, columnsA, columnsB, setColumns, setTableConnfig, 0, page, rowsPerPage, applicationTypeKey, searchKey, searchedVal));
    };
    const handleSearchKey = (e) => {
        const { name, value } = e.target;
        setSearchKey(value);



    };
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
       
        dispatch({ type: ActionTypes.FREE_USER_STATE, companiesListResponse });
        setState({
            ...fields,

            name_of_company:"",
            company_registration_date: "",
            company_registration_number: "",
            company_pan_number: "",

            company_contact_number: "",
            company_province: "",
            company_district: "",

            company_city: "",
            company_ward: "",
            company_place: "",
            company_email:"",
            id: null,
            changeStatus: false,
            fieldStatus: false,
            is_active: false
        });
        setOpen(false);
    };
    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched);
    };

    /*Edit Company Functionalities Section */

    const handleFieldChange = (e) => {
        
        if (fields[e.target.name] != e.target.value) {
            setState({
                ...fields, changeStatus: true,
                [e.target.name]: e.target.value,
            })


        }
        if (e.target.name == "company_province") {
            {

                Geographical.length && Geographical.map((option) => (

                    (option.name == e.target.value) ?
                        option.districts.map((district, index) => (
                            (index == 0) ?
                                setState({
                                    ...fields,
                                    changeStatus: true,
                                    [e.target.name]: e.target.value,
                                    ['company_district']: district.name,
                                    ['company_city']: district.municipalities.filter((municipality, index) => (index === 0 ? true : false))[0].name,
                                    ['company_ward']: 1
                                }) : true

                        ))
                        : true


                ))
            }

        } else if (e.target.name === "company_district") {
            {
                Geographical.length && Geographical.map((option) => (
                    option.districts.map((option) => (
                        (option.name === e.target.value) ?
                            option.municipalities.map((municipality, index) => (
                                (index == 0) ?
                                    setState({
                                        ...fields,
                                        changeStatus: true,
                                        [e.target.name]: e.target.value,
                                        ['company_city']: municipality.name,
                                        ['company_ward']: 1
                                    }) : true
                            )) : true
                    ))
                ))

            }
        } else if (e.target.name === "company_city") {
            setState({
                ...fields,
                changeStatus: true,
                [e.target.name]: e.target.value,
                ['company_ward']: 1
            })
        }
        else {
            setState({
                ...fields,
                changeStatus: true,
                [e.target.name]: e.target.value,
            });
        }
        if (e.target.name === 'is_active') {
            
            setState({
                ...fields, changeStatus: true,
                [e.target.name]: e.target.value,
            })
        }

    };


    const handleFieldChangeRadio = (e) => {
        setState({
            ...fields, changeStatus: true,
            [e.target.name]: e.target.value,
        })

    }

    const handleFieldChangePhone = (value) => {
       
        if (fields['contact_no'] != value) {
            setState({
                ...fields, changeStatus: true,
                'contact_no': value,
            })
        }
    }
   

    const UpdateCompany = (e) => {
        e.preventDefault();
      
        let company_province ='';
        let company_district = '';
        let company_city = '';
        Geographical.map((option) => (

            (option.name == fields.company_province) ?
                company_province = option.id
                : true


        ))
       Geographical.map((option) => (
            option.districts.map((option) => (
                option.name == fields.company_district ? company_district = option.id:true
                    
            ))
        ))

        Geographical.map((option) => (
            option.districts.map((option) => (
                
                    option.municipalities.map((municipality, index) => (
                        (municipality.name == fields.company_city) ? company_city = municipality.id:true
                            
                    
            ))
        ))
        ))
        let temp_object = {
            ...fields,
            company_province: company_province,
            company_district: company_district,
            company_city: company_city
        };
      
         
        dispatch(updateCompanyAction(temp_object, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setCompanies));
        setRows(companies);
        setState({
            ...fields, changeStatus: false,
            fieldStatus: true,
        });
    };
 
    const handleChangePage = (event, newPage) => {
        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal;  
        setPage(newPage);
        dispatch(companyListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setCompanies, signal, setCompanyEditFlag, columnsA, columnsB, setColumns, setTableConnfig, 0, newPage, rowsPerPage, applicationTypeKey, searchKey, searchKeyValue));
    };
    const handleChangeRowsPerPage = (event) => {
        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal;  
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        dispatch(companyListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setCompanies, signal, setCompanyEditFlag, columnsA, columnsB, setColumns, setTableConnfig, 0, page, event.target.value, applicationTypeKey, searchKey, searchKeyValue));
    };

    /*End of Edit User Functionalities Section */
    useEffect(() => {
        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal;  
        dispatch(companyListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setCompanies, signal, setCompanyEditFlag, columnsA, columnsB, setColumns, setTableConnfig, 0, page, rowsPerPage, applicationTypeKey));
       
       
        return () => { 
         abortController.abort() };
    }, [setRestrictedStatus || rows]);

    return (
        <>
            <div className={classes.root}>
                {restrictedStatus &&
                    <> <Grid container className={classes.bodyWrapper}>
                        <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

                        </Grid>
                    </Grid>
                    </>
                }
                {!restrictedStatus && bodyStatus &&
                <Grid container className={classes.bodyWrapper}>
                        <Grid item xs={2}></Grid>

                        <Grid item xs={10} md={10} className={classes.rightSideContent} style={{ marginTop: "25px" }}>
                        <Typography variant="h6" component="div" style={{ position: "relative", textAlign: "left", marginBottom: "15px" }} gutterBottom>
                            List of Companies
                        </Typography>
                            <Grid container item xs={10} md={10} style={{marginBottom:"25px"}}>
                                <Grid item md={3} xs={12} className={classes.searchBox} >
                                <SearchBar
                                    value={searched}
                                    onChange={(searchVal) => requestSearch(searchVal)}
                                    onCancelSearch={() => cancelSearch()}
                                />
                            </Grid>
                                <Grid item md={3} xs={12} >
                                    <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                                    <InputLabel>Search Type</InputLabel>
                                <Select
                                    name="search_key"
                                    label={"Search Type"}
                                        value={searchKey}
                                        onChange={handleSearchKey}
                                  
                                >
                                     
                                    {Object.keys(labelList).map((key) => (
                                            <MenuItem key={key} value={key}>
                                                {labelList[key]}
                                        </MenuItem>
                                    ))}
                                </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container item xs={10}>
                            <Grid xs={12}>
                            <div className={classes.MuiDataGrid_windowContainer}>
                                       
                                {companies.length !== 0 ? (
                                    <>
                                     <TableContainer className={classes.container}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                {columns.map((column) => {
                                                    if(column.field.localeCompare("actions")){
                                                        
                                                  
                                                    return (<TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={{ minWidth: column.minWidth }}
                                                    >
                                                        {column.headerName}
                                                    </TableCell>)
                                                    }else{
                                                        return (<TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            style={{ minWidth: column.minWidth }}
                                                        >
                                                            {column.headerName}
                                                        </TableCell>)
                                                    }
                                                })
}
                                             
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row,index) => {
                                                    return (
                                                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                            {columns.map((column) => {
                                                                const value = row[column.field];
                                                                if (!column.field.localeCompare("actions")) {
                                                                    return (<TableCell key={column.field}>
                                                                    <div
                                                                        style={{
                                                                            textAlign: "center",
                                                                            paddingLeft: "15px",
                                                                            paddingRight: "15px",
                                                                            }} 
                                                                            key={column.field}
                                                                    >
                                                                            {companyEditFlag &&
                                                                                <EditIcon
                                                                                    color="primary"
                                                                                    onClick={(event) => {
                                                                                        editUser(event, row);
                                                                                    }}
                                                                                    
                                                                                />
                                                                            }
                                                                    </div>
                                                              
                                                            </TableCell>)
                                                                } else if (!column.field.localeCompare("name_of_company")){
                                                                    return (
                                                                     <TableCell key={column.field} >
                                                                            <span style={{ fontWeight: "bold" }}>  {value} </span><br/>
                                                                           <span style={{fontSize:"13px"}}> {row.company_province} - {row.company_district}  - {row.company_city} -- {row.company_ward}</span>
                                                                    </TableCell>
                                                                    )
                                                                }
                                                                else if (!column.field.localeCompare("company_registration_date")) {
                                                                    return (
                                                                        <TableCell key={column.field} >
                                                                            
                                                                            <span> <span style={{ fontWeight: "bold" }}> Reg. Date :</span> <span style={{ fontSize: "13px" }}> {row.company_registration_date} </span></span><br />
                                                                             <span><span style={{ fontWeight: "bold" }}>Reg. No : </span><span style={{ fontSize: "13px" }}> {row.company_registration_number}</span> </span><br />
                                                                            <span> <span style={{ fontWeight: "bold" }}>PAN. No : </span><span style={{ fontSize: "13px" }}> {row.company_registration_number}</span> </span><br />
                                                                        </TableCell>
                                                                    )
                                                                }else{
                                                                return (
                                                                    <TableCell key={column.field} >
                                                                        {value}
                                                                    </TableCell>
                                                                );
                                                                }
                                                            }) }
                                                            {
                                                         
                                                           
                                                          
                                                            }
                                                            
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                            </Table>
                                            </TableContainer>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 25, 100]}
                                                    component="div"
                                                    count={tableConfig.total}
                                                    rowsPerPage={parseInt(tableConfig.per_page)}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
            </>                       
                                ) : (
                                    <div className={classes.beforeLoad}>
                                        Displaying Company List...
                                    </div>
                                )}
                            </div>
                            </Grid>
                        </Grid>
                        <div>
                            <Dialog
                                onClose={handleClose}
                                aria-labelledby="customized-dialog-title"
                                open={open}
                                fullWidth
                                maxWidth="lg"
                            >
                                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                                    <b
                                        className={classes.primary}
                                        style={{ textAlign: "center" }}
                                    >
                                        Edit Company
                                    </b>
                                </DialogTitle>
                                <DialogContent dividers>
                                    {companiesListResponse.success == false &&
                                            companiesListResponse.updatedCompany != "" &&
                                        fields.fieldStatus == true ? (
                                        <div className={classes.customFail}>
                                                {companiesListResponse.message}
                                        </div>
                                    ) : companiesListResponse.success == true &&
                                                companiesListResponse.updatedCompany &&
                                        fields.fieldStatus == true ? (
                                        <div className={classes.customSuccess}>
                                                    {companiesListResponse.message}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <form >
                                        <Grid container item xs={12}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="text"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Name Of Company"
                                                    id="name_of_company"
                                                    name="name_of_company"
                                                    value={fields.name_of_company}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="text"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                        label="Company Registration Date"
                                                        id="company_registration_date"
                                                        name="company_registration_date"
                                                        value={fields.company_registration_date}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="text"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                        label="PAN Number"
                                                        id="company_pan_number"
                                                        name="company_pan_number"
                                                        value={fields.company_pan_number}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        type="text"
                                                        className={classes.fullWidth}
                                                        required
                                                        margin="normal"
                                                        variant="outlined"
                                                        label="Registration Number"
                                                        id="company_registration_number"
                                                        name="company_registration_number"
                                                        value={fields.company_registration_number}
                                                        onChange={handleFieldChange}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                <FormControl variant="outlined" className={classes.formControl} >
                                                    <InputLabel>Select Province</InputLabel>
                                                    <Select
                                                        name="company_province"
                                                        id="company_province"
                                                        label="Select Province"
                                                        value={fields.company_province}
                                                        onChange={handleFieldChange}
                                                            className={classes.fullWidth}
                                                    >

                                                        {Geographical.map((option) => (
                                                            <MenuItem key={option.id} value={option.name}>
                                                                {option.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                </Grid>
                                            

                                                <Grid item xs={12} sm={3}>

                                                    <FormControl variant="outlined" className={classes.formControl}>
                                                        <InputLabel>Select District</InputLabel>
                                                        <Select
                                                            name="company_district"
                                                            id="company_district"
                                                            label="Select District"
                                                            value={fields.company_district}
                                                            className={classes.fullWidth}
                                                            onChange={handleFieldChange}
                                                        >

                                                            {Geographical.map((option) => (

                                                                (option.name === fields.company_province) ?
                                                                    option.districts.map((option) => (
                                                                        <MenuItem key={option.id} value={option.name}>
                                                                            {option.name}

                                                                        </MenuItem>
                                                                    ))
                                                                    : true


                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={3}>

                                                    <FormControl variant="outlined" className={classes.formControl} >
                                                        <InputLabel>Select City</InputLabel>
                                                        <Select
                                                            name="company_city"
                                                            id="company_city"
                                                            label="Select City"
                                                            value={fields.company_city}
                                                            onChange={handleFieldChange}
                                                            className={classes.fullWidth}
                                                        >

                                                            {Geographical.map((option) => (

                                                                option.districts.map((option) => (

                                                                    (option.name === fields.company_district) ?
                                                                        option.municipalities.map((option) => (
                                                                            <MenuItem key={option.id} value={option.name}>
                                                                                {option.name}

                                                                            </MenuItem>
                                                                        ))

                                                                        : true
                                                                ))
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={3}>

                                                    <FormControl variant="outlined" className={classes.formControl}>
                                                        <InputLabel>Select Ward</InputLabel>
                                                        <Select
                                                            name="company_ward"
                                                            id="company_ward"
                                                            label="Select Ward"
                                                            value={fields.company_ward}
                                                            onChange={handleFieldChange}
                                                            className={classes.fullWidth}
                                                        >

                                                            {Geographical.map((option) => (

                                                                option.districts.map((option) => (

                                                                    option.municipalities.map((option) => (
                                                                        (option.name == fields.company_city) ?
                                                                            option.wards.map((ward) => (
                                                                                <MenuItem key={ward} value={ward}>
                                                                                    Ward {ward}

                                                                                </MenuItem>
                                                                            )) : true
                                                                    ))
                                                                ))
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                               
                                                <Grid item xs={6}>
                                                    <TextField
                                                        type="text"
                                                        className={classes.fullWidth}
                                                        required
                                                        margin="normal"
                                                        variant="outlined"
                                                        label="Place"
                                                        id="company_place"
                                                        name="company_place"
                                                        value={fields.company_place}
                                                        onChange={handleFieldChange}
                                                    />
                                                </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="email"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Company Email"
                                                        id="company_email"
                                                        name="company_email"
                                                        value={fields.company_email}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <PhoneInput
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Contact Number"
                                                    country="np"
                                                    placeholder="9843125689"
                                                        id='company_contact_number'
                                                    name='company_contact_number'

                                                    containerStyle={{
                                                        marginTop: "20px",
                                                        marginBottom: "25px"
                                                    }}
                                                    inputStyle={{ width: "80%", verticleAlign: "middle", borderColor: (props.touched && props.error) && "red" }}

                                                    onlyCountries={['np']}
                                                    value={fields.company_contact_number}
                                                    onChange={(value, country, e, formattedValue) => handleFieldChangePhone(value, country, e, formattedValue)}
                                                    disableDropdown
                                                    disableCountryCode
                                                    isValid={(value, country) => {
                                                        var reg = new RegExp('^((98))[0-9]{8}$', 'i');
                                                        if (!reg.test(value)) {
                                                            return false;
                                                        }
                                                        if (value.length == 10) {
                                                            return true;
                                                        } else {
                                                            return false;
                                                        }
                                                    }}
                                                />

                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl>
                                                    <FormLabel>Company Status</FormLabel>
                                                        <RadioGroup
                                                            name="is_active"
                                                            id="is_active"
                                                            value={fields.is_active}
                                                            onChange={handleFieldChangeRadio}
                                                            row
                                                        >
                                                            <FormControlLabel
                                                                key="Active"
                                                                value="Active"
                                                                control={<Radio size="small" />}
                                                                label="Active"
                                                                variant="outlined"
                                                                checked={fields.is_active == "Active" ? true : false}
                                                            />
                                                            <FormControlLabel
                                                                key="Inactive"
                                                                value="Inactive"
                                                                control={<Radio size="small" />}
                                                                label="Inactive"
                                                                variant="outlined"
                                                                checked={fields.is_active == "Inactive" ? true : false}
                                                            />
                                                        </RadioGroup>
                                                </FormControl>
                                            </Grid>

                                        </Grid>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button autoFocus onClick={UpdateCompany} className={[classes.customButton].join(" ")}
                                        orientation="vertical"
                                        aria-label="vertical contained button group"
                                        variant="contained"
                                        color="primary"
                                        style={{ clear: "both" }}>
                                        Save changes
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </Grid>
                </Grid>
                 }
            </div>
        </>
    );
}
